import { useState } from "react";
import ReactECharts from "echarts-for-react";
import * as echarts from "echarts/core";
import * as S from "./RadialChart.style";

interface RadialChartProps {
  status?: boolean;
  color?: "green" | "blue";
  data?: any;
}

export const RadialChart = ({ status, color, data }: RadialChartProps) => {
  const [options, setOptions] = useState({
    color:
      status === false
        ? "#00000099"
        : color && color === "blue"
        ? "#46C6FF"
        : color && color === "green"
        ? "#00C572"
        : "#46C6FF",
    series: [
      {
        type: "gauge",
        radius: "100%",
        startAngle: 180,
        endAngle: 360,
        center: ["50%", "70%"],
        min: data.minValue,
        max: data.maxValue,
        progress: {
          show: true,
          width: 18,
        },
        detail: {
          show: true,
          valueAnimation: true,
          color: status ? "#ffffff" : "#00000099",
          fontSize: "2rem",
          offsetCenter: [0, "-4%"],
        },
        data: [data.value],
        splitLine: {
          show: false,
        },
        axisLine: {
          show: true,
          lineStyle: {
            width: 18,
            color: [[1, status === false ? "#00000014" : "#3832EA"]],
          },
        },
        axisTick: {
          show: false,
        },
        axisLabel: {
          show: false,
        },
        pointer: {
          show: false,
        },
      },
    ],
  });

  return (
    <S.RadialChartBox>
      <ReactECharts
        echarts={echarts}
        option={options}
        opts={{ renderer: "svg" }}
        style={{ width: "100%", height: "100%" }}
      />
      <S.RadialChartTick status={status}>
        <span>{data.minValue}</span>
        <span>{data.maxValue}</span>
      </S.RadialChartTick>
      <S.RadialChartUnitBox status={status}>{data.unit}</S.RadialChartUnitBox>
    </S.RadialChartBox>
  );
};
